/**
 * lib/views/javascripts/proto-voice.js — the entry module for the Proto
 * chat's live-voice client (lib/views/htmls/proto/voice.ejs; ADR 0082 D3).
 *
 * Its config — the chat's apiBase and the barge-in patterns from
 * lib/proto/voice/interrupt.js — arrives as boot data (#m33-voice-boot). It
 * runs after the chat's own module (document order), whose window API it
 * uses on events.
 *
 * Contents: view
 * Ontology: Code object M33C-1017 (immutable ref — assigned once, never edit)
 * Team: J. Brant Arseneau & the Mach33 Agents.
 */

import { readBootData } from './shared/boot-data.js';
import { mountVoice } from './proto/voice/client.js';

// ── Start ────────────────────────────────────────────────────────────────
mountVoice(readBootData(document, 'm33-voice-boot'));
